import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { InsightType } from '../types';
import { useIntl } from 'react-intl';
import { translateGroupName } from '../utils';

interface Props {
  reportsLegend: Array<InsightType>;
  setSection: (section: any) => void;
  selectedSection: string | undefined;
}

const Ol = styled.ol<{ padding?: string }>`
  list-style-type: none;
  padding: ${({ padding }) => (padding ? padding : '1rem 0')};
  margin: 0;
`;

const Li = styled.li<{ withBorder?: boolean }>`
  padding: 0;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  border-bottom: ${({ withBorder }) =>
    withBorder ? '1px solid #E6E6E5' : 'none'};
`;

const Title = styled(Typography)<{
  isActive: boolean;
}>`
  padding: 0.9rem 2rem;
  font-size: 0.875rem;

  ${({ isActive }) =>
    isActive &&
    `
  background-color:#F6F9FE;
`}
`;

const Legend = ({ setSection, reportsLegend, selectedSection }: Props) => {
  const { locale } = useIntl();

  return (
    <div>
      <Ol>
        {reportsLegend.map((interpretation, index) => {
          const { title } = interpretation;

          const translatedTitle = translateGroupName(title, locale);
          const isSelected =
            selectedSection && selectedSection === translatedTitle;
          return (
            <Li
              key={index}
              withBorder
              onClick={(e: any) => {
                e.stopPropagation();
                setSection(translatedTitle);
              }}
            >
              <Title isActive={!!isSelected} color="#253858">
                {translatedTitle}
              </Title>
            </Li>
          );
        })}
      </Ol>
    </div>
  );
};

export default Legend;
